<div class="flex flex-row justify-between pb-3 pr-4 relative items-center">
    <!-- <div class="flex flex-row items-center">
        <h2 mat-dialog-title class="!pl-0 text-2xl !m-0 font-bold !text-blue-theme-color"></h2>
    </div> -->
    <button mat-icon-button class="dialog-close-btn flex items-center justify-center" mat-dialog-close>
        <mat-icon class="text-blue-theme-color text-xl">close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mt-16 pt-4 !py-0">
    <div class="w-full  md:mt-6 sm:mt-3 mt-3">
        <img draggable="false" src="assets/images/ui/wallet-info.png" class="w-48 mx-auto" alt="">
    </div>
    <div class="w-full max-w-[500px] mx-auto md:mt-8 sm:mt-5 mt-5 text-center">
        <h3 class="md:text-3xl sm:text-xl text-xl text-blue-theme-color font-bold">Welcome to Phlenu Wallet!</h3>
        <p class="text-slate-grey md:text-base sm:text-sm text-sm md:mt-4 sm:mt-2 mt-2">Your one-stop solution for
            hassle-free orders.</p>
        <p
            class="md:text-base sm:text-sm text-sm font-semibold md:leading-6 sm:leading-5 leading-5 md:mt-4 sm:mt-2 mt-2 text-blue-theme-color">
            Tired of making payments every time you order? Our Wallet feature allows you to preload funds for quick, no
            fees and easy transactions!</p>
    </div>
</mat-dialog-content>
<mat-dialog-actions *ngIf="!this._data?.hideBtn" class="md:mt-4 sm:mt-2 mt-2 !pb-7 !px-0 justify-center">
    <button color="primary" routerLink="/wallet-transaction"
        class="!bg-blue-theme-color !rounded-none !h-11 text-white-color" mat-flat-button mat-dialog-close>Fund Your
        Phlenu Wallet</button>
</mat-dialog-actions>